import { createFileRoute, useNavigate } from "@tanstack/react-router";

import AggregateVideosView from "@/components/Creators/Dashboard/AggregateVideosView";
import { Id } from "@cvx/_generated/dataModel";
import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useAccount } from "@/state/useAccount";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/getInspired",
)({
  component: GetInspired,
  beforeLoad: () => ({
    title: "Content Ideas",
    headerTitle: "Content Ideas",
    headerDescription: "Discover trending content and connect with creators",
  }),
});

export default function GetInspired() {
  const { contractId } = useAccount();
  const navigate = useNavigate();

  const { data: contract, isLoading: isContractLoading } = useQuery({
    ...convexQuery(api.partnerships.getPartnership, {
      partnershipId: contractId as Id<"creatorContracts">,
    }),
    enabled: !!contractId,
  });

  useEffect(() => {
    if (!isContractLoading && contract?.partnership.status !== "active") {
      navigate({ to: "/dashboard" });
    }
  }, [contract, isContractLoading, navigate]);

  if (!contract) {
    return null;
  }

  return (
    <div className="flex min-h-screen w-full flex-col bg-background p-6">
      <div className="mx-auto w-full max-w-5xl">
        <AggregateVideosView campaign={contract.campaign} />
      </div>
    </div>
  );
}
